import React from 'react'

interface IcRequestedProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcRequested: React.FC<IcRequestedProps> = ({
  width = '16px',
  height = '16px',
  color = '#007AFF',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <g clipPath="url(#clip0_16187_975)">
        <path
          d="M8.74075 6.27777L10.963 8.5M10.963 8.5L8.74075 10.7222M10.963 8.5H5.03705M14.6667 8.5C14.6667 12.1819 11.6819 15.1667 8.00001 15.1667C4.31811 15.1667 1.33334 12.1819 1.33334 8.5C1.33334 4.8181 4.31811 1.83333 8.00001 1.83333C11.6819 1.83333 14.6667 4.8181 14.6667 8.5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16187_975">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IcRequested
